import React, { useState, useRef, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import redirectURL from "../redirectURL";

const ZONES = ["North", "South", "East", "West", "Central", "North East"];

export default function ZoneWiseBufferMaster() {
    const gridRef = useRef();

    const decipher = (salt) => {
        const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
        const applySaltToChar = (code) =>
            textToChars(salt).reduce((a, b) => a ^ b, code);
        return (encoded) =>
            (encoded || "")
                .match(/.{1,2}/g)
                ?.map((hex) => parseInt(hex, 16))
                .map(applySaltToChar)
                .map((charCode) => String.fromCharCode(charCode))
                .join("") || "";
    };
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
    const [fromZoneFilter, setFromZoneFilter] = useState("");
    const [toZoneFilter, setToZoneFilter] = useState("");
    const [resetKey, setResetKey] = useState(0);
    const [rowData, setRowData] = useState([]);
    const [entities, setEntities] = useState([]);
    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    const [showloader, setshowloader] = useState("show-n");
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState("add");
    const [editingIndex, setEditingIndex] = useState(null);
    const emptyForm = {
        from_zone: "",
        to_zone: "",
        entity: [],
        days: ""
    };

    const [modalForm, setModalForm] = useState(emptyForm);
    const [modalErrors, setModalErrors] = useState({});

    const clearFieldError = (field) => {
        setModalErrors((prev) => ({ ...prev, [field]: "" }));
    };

    useEffect(() => {
        loadEntities();
        loadData();
    }, []);
    useEffect(() => {
        if (fromZoneFilter === "" && toZoneFilter === "") {
            loadData();
        }
    }, [fromZoneFilter, toZoneFilter, resetKey]);


    const loadEntities = async () => {
        try {
            const resp = await redirectURL.post("/consignments/allEntityData", {});
            const raw = resp?.data?.data || resp?.data || [];

            const opts = [...new Set(raw.map((x) => x.entity || x.entity_name))]
                .filter(Boolean)
                .sort()
                .map((x) => ({ label: x, value: x }));

            setEntities(opts);
        } catch (err) {
            console.error("Entity load error:", err);
            setEntities([]);
        }
    };
    const loadData = async () => {
        setshowloader("show-m");
        const req = {
            from_zone: fromZoneFilter || null,
            to_zone: toZoneFilter || null
        };
        try {
            const resp = await redirectURL.post("/consignments/getZoneBuffer", req);
            if (resp?.data?.status === "success") {
                setRowData(
                    (resp.data.records || []).map((r) => ({
                        ...r,
                        _id: r._id ? r._id.toString() : null
                    }))
                );
            } else {
                setRowData([]);
            }
        } catch (err) {
            console.error("Load error:", err);
            setRowData([]);
        }
        setshowloader("show-n");
    };
    const resetFilters = () => {
        setFromZoneFilter("");
        setToZoneFilter("");
        setRowData([]);
        setResetKey(prev => prev + 1);
    };

    const openAddModal = () => {
        setModalMode("add");
        setEditingIndex(null);
        setModalForm(emptyForm);
        setModalErrors({});
        setShowModal(true);
    };
    const resetZoneModalForm = () => {
        setModalForm({
            from_zone: "",
            to_zone: "",
            entity: [],
            days: ""
        });

        setModalErrors({});
    };

    const openEditModal = (params) => {
        const d = params.data || {};

        setModalMode("edit");
        setEditingIndex(params.rowIndex);
        setModalForm({
            from_zone: d.from_zone || "",
            to_zone: d.to_zone || "",
            entity: Array.isArray(d.entity)
                ? d.entity
                : d.entity
                    ? d.entity.split(",")
                    : [],
            days: d.days ? String(d.days) : ""
        });
        setModalErrors({});
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setModalErrors({});
    };

    const validateModalForm = () => {
        let errors = {};

        if (!modalForm.from_zone) errors.from_zone = "From Zone is required";
        if (!modalForm.to_zone) errors.to_zone = "To Zone is required";
        if (!modalForm.entity || modalForm.entity.length === 0)
            errors.entity = "Entity is required";
        if (!modalForm.days)
            errors.days = "Days is required";
        else if (!/^\d{1,3}$/.test(modalForm.days))
            errors.days = "Days must be numeric";

        setModalErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleModalSave = async () => {
        if (!validateModalForm()) return;

        const f = modalForm;
        const entityArray = f.entity;  // keep array
        const newEntities = f.entity;

        const currentId = editingIndex !== null ? rowData[editingIndex]._id : null;

        // rows with same zones excluding current row
        // const sameRows = rowData.filter(r =>
        //     r._id !== currentId &&
        //     r.from_zone === f.from_zone &&
        //     r.to_zone === f.to_zone
        // );

        // // gather all existing entities from all rows
        // let existingEntities = [];
        // sameRows.forEach(r => {
        //     existingEntities = existingEntities.concat(r.entity.split(","));
        // });

        // RULE 1 — block exact duplicate
        // if (sameRows.some(r => r.entity === entityString)) {
        //     return setModalErrors({
        //         entity: "This From Zone, To Zone & Entity combination already exists!"
        //     });
        // }

        // // RULE 2 — ANY entity already used cannot be used again
        // // (THIS IS WHERE your new rule is applied)
        // const duplicateEntity = newEntities.find(ent =>
        //     existingEntities.includes(ent)
        // );

        // if (duplicateEntity) {
        //     return setModalErrors({
        //         entity: `Entity '${duplicateEntity}' already exists for these zones!`
        //     });
        // }
        // rows with same zones excluding current row
        const sameRows = rowData.filter(r =>
            r._id !== currentId &&
            r.from_zone === f.from_zone &&
            r.to_zone === f.to_zone
        );

        // collect all existing entities from those rows
        let existingEntities = [];
        sameRows.forEach(r => {
            if (Array.isArray(r.entity)) {
                existingEntities = existingEntities.concat(r.entity);
            } else if (typeof r.entity === "string") {
                existingEntities = existingEntities.concat(r.entity.split(","));
            }
        });

        // check if any selected entity already exists
        const duplicateEntity = f.entity.find(ent =>
            existingEntities.includes(ent)
        );

        if (duplicateEntity) {
            return setModalErrors({
                entity: `Entity '${duplicateEntity}' already exists for these zones!`
            });
        }


        // proceed save…
        const newRecord = {
            _id: currentId,
            from_zone: f.from_zone,
            to_zone: f.to_zone,
            entity: f.entity,
            days: Number(f.days)
        };

        setshowloader("show-m");

        const payload = {
            record: newRecord,
            unique_id: newRecord._id || null,
            email: decode(localStorage.getItem("email")) || "system"
        };

        try {
            const resp = await redirectURL.post("/consignments/saveZoneBuffer", payload);

            if (resp?.data?.status === "success") {
                setBasicType("success");
                setBasicTitle("Saved Successfully!");
                setShow(true);
                closeModal();
                loadData();
            } else {
                setModalErrors({
                    entity: resp?.data?.message || "Save failed"
                });
            }

        } catch (err) {
            setModalErrors({
                entity: "Server error. Please try again."
            });
        } finally {
            setshowloader("show-n");
        }
    };


    const columnDefs = [
        {
            headerName: "",
            width: 120,
            cellRenderer: (params) => (
                <button
                    className="btn btn-primary"
                    style={{
                        width: "70px",
                        height: "30px",
                        fontSize: "13px",
                        padding: "0px"
                    }}
                    onClick={() => openEditModal(params)}
                >
                    Edit
                </button>
            )
        },
        { headerName: "From Zone", field: "from_zone", width: 150 },
        { headerName: "To Zone", field: "to_zone", width: 150 },
        { headerName: "Entity", field: "entity", width: 220 },
        { headerName: "Days", field: "days", width: 120 }
    ];

    const defaultColDef = {
        resizable: true,
        sortable: true,
        filter: true
    };

    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={() => setShow(false)}
            />

            <div className="card">
                <div className="card-body">

                    <div className="row align-items-end">

                        {/* From Zone */}
                        <div className="col-xl-2 col-lg-3">
                            <label>From Zone</label>
                            <Select
                                options={ZONES.map(z => ({ label: z, value: z }))}
                                value={fromZoneFilter ? { label: fromZoneFilter, value: fromZoneFilter } : null}
                                onChange={(e) => setFromZoneFilter(e ? e.value : "")}
                                isClearable
                            />
                        </div>

                        {/* To Zone */}
                        <div className="col-xl-2 col-lg-3">
                            <label>To Zone</label>
                            <Select
                                options={ZONES.map(z => ({ label: z, value: z }))}
                                value={toZoneFilter ? { label: toZoneFilter, value: toZoneFilter } : null}
                                onChange={(e) => setToZoneFilter(e ? e.value : "")}
                                isClearable
                            />
                        </div>

                        {/* Get Data + Reset */}
                        <div className="col-xl-3 col-lg-3 d-flex align-items-end" style={{ paddingTop: 28 }}>
                            <button className="btn btn-success" onClick={loadData}>
                                Get Data
                            </button>
                            <button className="btn btn-default ms-2" onClick={resetFilters}>
                                Reset
                            </button>
                        </div>

                        {/* Add Row - fully right aligned */}
                        <div className="col-xl-5 col-lg-3 d-flex justify-content-end align-items-end" style={{ paddingTop: 28 }}>
                            <button className="btn btn-primary" onClick={openAddModal}>
                                + Add Row
                            </button>
                        </div>

                    </div>


                    <div
                        className="ag-theme-balham mt-3"
                        style={{ height: "500px", width: "100%" }}
                    >
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                ...defaultColDef,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                cellStyle: {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px"
                                }
                            }}
                            rowHeight={32}
                            pagination={true}
                            paginationPageSize={20}
                        />
                    </div>
                </div>
            </div>

            {showModal && (
                <>
                    <div className="modalOverlay" onClick={closeModal}></div>

                    <div
                        className="rightModal"
                        style={{
                            position: "fixed",
                            top: 0,
                            right: 0,
                            width: "420px",
                            height: "100vh",
                            background: "#fff",
                            zIndex: 9999,
                            padding: "20px",
                            overflowY: "auto",
                            boxShadow: "-3px 0 10px rgba(0,0,0,0.2)"
                        }}
                    >
                        <button
                            className="close"
                            onClick={closeModal}
                            style={{
                                position: "absolute",
                                top: "15px",
                                right: "15px",
                                fontSize: "26px",
                                fontWeight: "700",
                                border: "none",
                                background: "transparent",
                                cursor: "pointer"
                            }}
                        >
                            &times;
                        </button>

                        <div
                            style={{
                                backgroundColor: "#1F6F8B",
                                color: "white",
                                padding: "12px 0",
                                textAlign: "center",
                                fontSize: "18px",
                                fontWeight: "600",
                                position: "relative",
                                margin: "-20px -20px 20px -20px"
                            }}
                        >
                            {editingIndex === null
                                ? "Add Zone Buffer"
                                : "Edit Zone Buffer"}

                            <button
                                onClick={closeModal}
                                style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: "32px",
                                    height: "32px",
                                    borderRadius: "50%",
                                    border: "none",
                                    backgroundColor: "#0B3C5D",
                                    color: "white",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    cursor: "pointer",
                                    padding: 0,
                                    lineHeight: "32px",
                                    textAlign: "center"
                                }}
                            >
                                X
                            </button>
                        </div>

                        <label>
                            From Zone <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            className="mb-1"
                            options={ZONES.map((z) => ({ label: z, value: z }))}
                            value={
                                modalForm.from_zone
                                    ? { label: modalForm.from_zone, value: modalForm.from_zone }
                                    : null
                            }
                            onChange={(e) => {
                                setModalForm((p) => ({
                                    ...p,
                                    from_zone: e ? e.value : ""
                                }));
                                clearFieldError("from_zone");
                            }}
                            isClearable
                        />
                        {modalErrors.from_zone && (
                            <div style={{ color: "red" }}>{modalErrors.from_zone}</div>
                        )}

                        <label>
                            To Zone <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                            className="mb-1"
                            options={ZONES.map((z) => ({ label: z, value: z }))}
                            value={
                                modalForm.to_zone
                                    ? { label: modalForm.to_zone, value: modalForm.to_zone }
                                    : null
                            }
                            onChange={(e) => {
                                setModalForm((p) => ({
                                    ...p,
                                    to_zone: e ? e.value : ""
                                }));
                                clearFieldError("to_zone");
                            }}
                            isClearable
                        />
                        {modalErrors.to_zone && (
                            <div style={{ color: "red" }}>{modalErrors.to_zone}</div>
                        )}

                        <label>
                            Entity <span style={{ color: "red" }}>*</span>
                        </label>

                        <Select
                            isMulti
                            className="mb-1"
                            options={entities.map((ent) => ({
                                label: ent.label,
                                value: ent.value
                            }))}  // ✔ Only normal entities, NO ALL
                            value={modalForm.entity.map((v) => ({
                                label: v,
                                value: v
                            }))}
                            onChange={(selected) => {
                                const values = selected.map((s) => s.value);

                                setModalForm((p) => ({
                                    ...p,
                                    entity: values 
                                }));

                                clearFieldError("entity");
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                            }}
                        />

                        {modalErrors.entity && (
                            <div style={{ color: "red" }}>{modalErrors.entity}</div>
                        )}


                        <label>
                            Days <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className="form-control mb-1"
                            value={modalForm.days}
                            onChange={(e) => {
                                const v = e.target.value.replace(/\D/g, "");
                                if (v.length <= 3)
                                    setModalForm((p) => ({ ...p, days: v }));
                                clearFieldError("days");
                            }}
                        />
                        {modalErrors.days && (
                            <div style={{ color: "red" }}>{modalErrors.days}</div>
                        )}

                        <div
                            className="mt-3"
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            }}
                        >
                            <button
                                className="btn"
                                style={{
                                    width: "100px",
                                    height: "40px",
                                    fontSize: "15px",
                                    marginRight: "4px",
                                    backgroundColor: "#a6a7a8ff", borderColor: "#a6a7a8ff",
                                    borderRadius: "5px"
                                }}
                                onClick={resetZoneModalForm}
                            >
                                Reset
                            </button>
                            <button
                                className="btn btn-secondary"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    marginRight: "6px"
                                }}
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button className="btn btn-success"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    borderRadius: "5px"
                                }}
                                onClick={handleModalSave}>
                                Save
                            </button>
                        </div>
                    </div>
                </>
            )}
            <div className={"dataLoadpage " + showloader}></div>
            <div className={"dataLoadpageimg " + showloader}>
                <div className="loader-box">
                    <div className="rotate dashed colored"></div>
                </div>
            </div>
        </div>
    );
}